import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import avatar from "../../../images/avatar/1.jpg";
import LogoutLink from "./Logout";
import ChangePasswordModal from "../../components/auth/ChangePasswordModal";
import { useSelector, useDispatch } from "react-redux";
import {
  getUserInfo,
  checkAuthorization
} from "../../../store/slices/authSlice";
import { getClinicInfo } from "../../../store/slices/clinicSlice";
import { getPhysicianInfo } from "../../../store/slices/physicianSlice";
import LowStockDropdown from "../stockInventory/lowStock";

const Header = () => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo, token } = useSelector((state) => state.auth);
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    dispatch(checkAuthorization());
  }, [dispatch, navigate]);

  useEffect(() => {
    dispatch(getUserInfo({ userId: userInfo?._id, token }));
    dispatch(getClinicInfo({ userId: userInfo?._id, token }));
    dispatch(getPhysicianInfo({ userId: userInfo?._id, token }));
  }, [dispatch, userInfo?._id, token]);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
              >
                {path === "/" ? "Dashboard" : path.split("/")[1]}
              </div>
            </div>
            <ul className="navbar-nav header-right">
         
              {/* <LowStockDropdown /> */}
           
          
              <Dropdown as="li" className={`nav-item header-profile `}>
                <Dropdown.Toggle className="nav-link i-false" as="a">
                  {userInfo?.profilePic ? (
                    <img src={userInfo.profilePic} width={20} alt="Profile Pic" />
                  ) : (
                    <div style={{
                      borderRadius: "50%",
                      padding: "0.3rem 0.7rem",
                      backgroundColor: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
                      border: "none",
                      fontSize: "1.3rem",
                      color: "#fff",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "2.8rem",
                      height: "2.8rem",
                    }}>
                      {userInfo?.name?.charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div className="header-info">
                    <span className="text-start fs-15">
                      Hello, <br />
                      <strong className="font-w600 fs-15"> {userInfo?.name}</strong>
                    </span>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align={"end"} className={`dropdown-menu-right`}>
                  <Link to="/userProfile" className="dropdown-item ai-icon">
                    <svg
                      id="icon-user1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-primary"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ms-2">Profile </span>
                  </Link>
                  <Link to="./email-inbox" className="dropdown-item ai-icon">
                    <svg
                      id="icon-inbox"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-success"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <span className="ms-2">Inbox </span>
                  </Link>
                  <LogoutLink />
                  <div onClick={handleShow} className="dropdown-item ai-icon">
                    <svg
                      id="icon-user1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-primary"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ms-2">Change Password </span>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
      <ChangePasswordModal show={show} handleClose={handleClose} />
    </div>
  );
};

export default Header;
